export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Premium Bank',
    headline: 'Unlimited Transactions with zero fees',
    description: 'Get access to our exclusive app that allows yoi to send unlimited transactions without getting charged any feed',
    buttonLabel: 'Get started',
    imgStart: false,
    img: require('../../images/car.svg'),
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false
}


export const homeObjTwo = {
    id: 'discover',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Unlimited access',
    headline: 'Unlimited Transactions with zero fees',
    description: 'Get access to our exclusive app that allows yoi to send unlimited transactions without getting charged any feed',
    buttonLabel: 'Learn more',
    imgStart: true,
    img: require('../../images/save.svg'),
    alt: 'Piggybank',
    dark: false,
    primary: false,
    darkText: true
}

export const homeObjThree = {
    id: 'signup',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Join our team',
    headline: 'Unlimited Transactions with zero fees',
    description: 'Get access to our exclusive app that allows yoi to send unlimited transactions without getting charged any feed',
    buttonLabel: 'Join us',
    imgStart: false,
    img: require('../../images/chart.svg'),
    alt: 'Car',
    dark: false,
    primary: false,
    darkText: true
}